import { ErrorPathEnum } from "@app/routes/components/Error/error.paths";

export const check500Error = (err: any) => {
  if (err?.response?.status === 500) {
    window.location.replace(ErrorPathEnum.ERROR);
  }
};
